const compatModules = {};import * as Mod1 from "./discourse/controllers/admin-plugins-proxyviews-analytics";
compatModules["discourse/controllers/admin-plugins-proxyviews-analytics"] = Mod1;

export * as discourse$controllers$admin__plugins__proxyviews__analytics$$__module from "./discourse/controllers/admin-plugins-proxyviews-analytics";
export {
default as discourse$controllers$admin__plugins__proxyviews__analytics$$default
} from "./discourse/controllers/admin-plugins-proxyviews-analytics";
import * as Mod2 from "./discourse/controllers/admin-plugins/proxyviews-analytics";
compatModules["discourse/controllers/admin-plugins/proxyviews-analytics"] = Mod2;

export * as discourse$controllers$admin__plugins$proxyviews__analytics$$__module from "./discourse/controllers/admin-plugins/proxyviews-analytics";
export {
default as discourse$controllers$admin__plugins$proxyviews__analytics$$default
} from "./discourse/controllers/admin-plugins/proxyviews-analytics";
import * as Mod3 from "./discourse/initializers/analytics";
compatModules["discourse/initializers/analytics"] = Mod3;

export * as discourse$initializers$analytics$$__module from "./discourse/initializers/analytics";
export {
default as discourse$initializers$analytics$$default
} from "./discourse/initializers/analytics";
import * as Mod4 from "./discourse/proxyviews-analytics-route-map";
compatModules["discourse/proxyviews-analytics-route-map"] = Mod4;

export * as discourse$proxyviews__analytics__route__map$$__module from "./discourse/proxyviews-analytics-route-map";
export {
default as discourse$proxyviews__analytics__route__map$$default
} from "./discourse/proxyviews-analytics-route-map";
import * as Mod5 from "./discourse/routes/admin-plugins-proxyviews-analytics";
compatModules["discourse/routes/admin-plugins-proxyviews-analytics"] = Mod5;

export * as discourse$routes$admin__plugins__proxyviews__analytics$$__module from "./discourse/routes/admin-plugins-proxyviews-analytics";
export {
default as discourse$routes$admin__plugins__proxyviews__analytics$$default
} from "./discourse/routes/admin-plugins-proxyviews-analytics";
import * as Mod6 from "./discourse/routes/admin-plugins/proxyviews-analytics";
compatModules["discourse/routes/admin-plugins/proxyviews-analytics"] = Mod6;

export * as discourse$routes$admin__plugins$proxyviews__analytics$$__module from "./discourse/routes/admin-plugins/proxyviews-analytics";
export {
default as discourse$routes$admin__plugins$proxyviews__analytics$$default
} from "./discourse/routes/admin-plugins/proxyviews-analytics";
import * as Mod7 from "./discourse/services/proxyviews-experiments";
compatModules["discourse/services/proxyviews-experiments"] = Mod7;

export * as discourse$services$proxyviews__experiments$$__module from "./discourse/services/proxyviews-experiments";
export {
default as discourse$services$proxyviews__experiments$$default
} from "./discourse/services/proxyviews-experiments";
import * as Mod8 from "./discourse/templates/admin-plugins-proxyviews-analytics";
compatModules["discourse/templates/admin-plugins-proxyviews-analytics"] = Mod8;

export * as discourse$templates$admin__plugins__proxyviews__analytics$$__module from "./discourse/templates/admin-plugins-proxyviews-analytics";
export {
default as discourse$templates$admin__plugins__proxyviews__analytics$$default
} from "./discourse/templates/admin-plugins-proxyviews-analytics";
import * as Mod9 from "./discourse/templates/admin-plugins/proxyviews-analytics";
compatModules["discourse/templates/admin-plugins/proxyviews-analytics"] = Mod9;

export * as discourse$templates$admin__plugins$proxyviews__analytics$$__module from "./discourse/templates/admin-plugins/proxyviews-analytics";
export {
default as discourse$templates$admin__plugins$proxyviews__analytics$$default
} from "./discourse/templates/admin-plugins/proxyviews-analytics";
export default compatModules;
